import React from "react";
import { selectLoading } from "modules/notification";
import { useSelector } from "react-redux";
import ConsumerEngagementReportComponents from "./consumerEngagementReport.page";
import { getCompanyDisbursement } from "modules/account/redux";

function ConsumerEngagementReportContainer() {
  const lang = useSelector((state) => state.constant.languages);
  const isFetching = useSelector((state) =>
    selectLoading(state, getCompanyDisbursement.typePrefix)
  );
  const disbursementInfos = useSelector(
    (state) => state.account.disbursementInfos
  );

  return (
    <ConsumerEngagementReportComponents
      lang={lang}
      disbursementInfos={disbursementInfos}
      isFetching={isFetching}
    />
  );
}

export default ConsumerEngagementReportContainer;
